import { VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { calculatePercentageWidth } from '../../../constants';

import { skeletonWidthCols } from './constants';

import { SkeletonProps } from '.';

interface DesktopProps extends Partial<SkeletonProps> {}

export const Desktop: React.FC<DesktopProps> = ({ viewportType }) => {
  const items = Object.keys(skeletonWidthCols);

  const skeleton = items.map((item) => {
    const value = skeletonWidthCols[item][viewportType];

    return (
      <VStack
        key={item}
        width={`${calculatePercentageWidth(value)}%`}
        justifyContent={'space-between'}
        py={Spacing['inline.nano']}
        space={Spacing['inline.nano']}>
        <Skeleton
          w="70%"
          h={Typography['fontsize.xl']}
          borderRadius={BoxRadius.sm}
          endColor={Color['brand.primary.lightest']}
        />
      </VStack>
    );
  });

  return skeleton;
};
